module.exports = "<div class=\"form-component\">\r\n  <div style=\"min-height:5px\" class=\"drag separator-designer\">\r\n    <hr />\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/text-editors/separator.designer.component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/designers/layout/text-editors/separator.designer.component.html
// module chunks = main